export const imageUrl_dev =
  "https://teamsproject.teamcomputers.com/plantmonitor-devapi";
export const imageUrl_uat =
  "https://teamsproject.teamcomputers.com/plantmonitor-api";
export const dateTimeFormat = "DD-MM-YYYY hh:mm:ss A";
export const roles = {
  USER: "user",
  ADMIN: "admin",
};
